import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useEffect, useMemo, useState } from "react";
import { format } from "date-fns";
import { Menu } from "lucide-react";
import GlobalSearch from "@/components/GlobalSearch";

const PAGE_TITLES = {
  "/": "Home",
  "/calendar": "Calendar",
  "/finance": "Finance",
  "/giving": "Finance",
  "/mailchimp": "Mailchimp Dashboard",
  "/kpi": "KPI Dashboard",
  "/documents": "Documents Hub",
  "/staff": "Staff Directory",
  "/people": "People",
  "/receipts": "Receipts",
  "/audit-log": "Audit Log",
  "/settings": "Settings & Admin",
};

export default function DashboardLayout() {
  const location = useLocation();
  const title = PAGE_TITLES[location.pathname] ?? "Dashboard";
  const today = useMemo(() => format(new Date(), "EEEE, MMMM d, yyyy"), []);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Close the mobile drawer on every route change so a tap-through nav doesn't
  // leave the drawer open over the new page.
  useEffect(() => { setMobileNavOpen(false); }, [location.pathname]);

  return (
    <div className="min-h-screen bg-cream">
      <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
      <div className="md:pl-72">
        <header
          className="sticky top-0 z-20 bg-cream/85 backdrop-blur-md border-b border-brand-primary/10"
          data-testid="app-header"
        >
          <div className="flex items-center justify-between gap-3 sm:gap-6 px-4 sm:px-6 md:px-10 py-4 md:py-5">
            <button
              type="button"
              data-testid="mobile-nav-toggle"
              onClick={() => setMobileNavOpen(true)}
              className="md:hidden p-2 -ml-2 rounded-lg text-brand-primary/70 hover:text-brand-primary hover:bg-brand-primary/5"
              aria-label="Open navigation"
            >
              <Menu className="h-6 w-6" />
            </button>
            <div className="min-w-0 flex-1">
              <p className="text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-terracotta font-semibold truncate">
                {today}
              </p>
              <h1 className="font-heading text-xl sm:text-2xl md:text-3xl font-semibold tracking-tight text-brand-primary mt-0.5 truncate">
                {title}
              </h1>
            </div>
            <div className="hidden md:block flex-shrink-0">
              <GlobalSearch />
            </div>
          </div>
        </header>
        <main className="px-4 sm:px-6 md:px-10 py-6 md:py-10 animate-fade-up">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
